export default "__VITE_ASSET__zfxbZPQA__"